// extracted by mini-css-extract-plugin
module.exports = {"jobContentLink":"jobContentLink","jobContentLink__title":"jobContentLink__title","jobContentLink__list":"jobContentLink__list"};